import React from 'react';

import classes from './DurationWrapper.scss';

const durationWrapper = (props) => (
    <div {...props} className={classes.Wrap}>
        {props.children}
    </div>
);

export default durationWrapper;


// WEBPACK FOOTER //
// ./src/components/Flight/Wrappers/DurationWrapper/DurationWrapper.js